import styled from "styled-components";
import IcCartEmpty from "../../images/icons/ic-cart-empty.svg";
import { COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";
import { Heading3, Subtitle1 } from "../../components/Typography";
import Button from "../../components/Button";

const ImgCartEmpty = styled.img`
  margin-bottom: 32px;
  margin-left: -52px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

const Title = styled.h1`
  ${Heading3}
  color: ${COLOR_YELLOW};
  margin-bottom: 12px;
`;

const Description = styled.p`
  ${Subtitle1}
  color: ${COLOR_WHITE};
  text-align: center;
`;

function CartEmpty() {
  return (
    <Container>
      <ImgCartEmpty src={IcCartEmpty} alt="Empty Cart" />
      <Title>Your cart is empty</Title>
      <Description className="mb-3 mb-md-4">
        Oops.. Looks like there is no product in your cart right now
        <br />
        Let’s browse a product to put in to your cart
      </Description>
      <a href="/">
        <Button variant="primary">Back to Home</Button>
      </a>
    </Container>
  );
}

export default CartEmpty;
